module.exports = __webpack_public_path__ + "img/Weapon_269.ef7c5aa0.png";